import type { ReactNode } from 'react';

import { useMediaQuery } from '../hooks/useMediaQuery';

/**
 * Od tejto šírky okna má Domov dva stĺpce. 1440 px je bežný 14–15" notebook
 * aj monitor: pod ňou by dva stĺpce vedľa bočného panela mali po ~420 px a
 * riadky „Tím dnes“ by sa lámali; nad ňou jeden stĺpec nechával polovicu
 * obrazovky prázdnu a súhrn s aktivitou bolo treba hľadať pod záhybom.
 */
export const DOMOV_WIDE_QUERY = '(min-width: 1440px)';

/**
 * Rozloženie karty „Dnes“ na Domove.
 *
 * Úzke: jeden stĺpec v poradí súhrn → tím → moje → aktivita (ako vždy).
 * Široké: vľavo to, na čom sa pracuje (Tím dnes, Moje dnešky), vpravo to, čo
 * sa číta (AI súhrn, zhrnutie dňa, aktivita). Prepína sa v JS, nie iba CSS
 * mriežkou: poradie je v stĺpcoch iné než v jednom prúde a čítačka obrazovky
 * aj Tab majú ísť v poradí, ktoré človek vidí.
 */
export const DomovLayout = ({
  summary,
  team,
  mine,
  activity,
}: {
  summary: ReactNode;
  team: ReactNode;
  mine: ReactNode;
  activity: ReactNode;
}) => {
  const wide = useMediaQuery(DOMOV_WIDE_QUERY);

  if (!wide) {
    return (
      <div className="space-y-7" data-columns="1">
        {summary}
        {team}
        {mine}
        {activity}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] items-start gap-8" data-columns="2">
      <div className="min-w-0 space-y-7">
        {team}
        {mine}
      </div>
      <div className="min-w-0 space-y-7">
        {summary}
        {activity}
      </div>
    </div>
  );
};
